module.exports = __webpack_public_path__ + "static/media/047.35852e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/047.jpg
// module id = 392
// module chunks = 0